import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  HostListener,
  EventEmitter,
  ElementRef,
  Renderer2,
  ViewChild,
  forwardRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownAnimation } from './dropdown-animations';
import { TagAnimation } from './tag-animations';
import { Subject } from 'rxjs/Subject';
import { ChineseToPinyinService } from './../core/service/chineseToPinyin.service';
@Component({
  selector: 'ant-select',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }, ChineseToPinyinService
  ],
  animations: [
    DropDownAnimation,
    TagAnimation
  ],
  template:`<div #rootEl style="display:inline-block;position:relative">
  <div class="ant-select-selection" #antSelect [ngClass]="{'ant-select-selection--single': !_mode,
'ant-select-selection--multiple': _mode}" (click)="isSelect($event)" [style.width]="_antWidth">
    <div class="ant-select-selection__rendered">
      <div *ngIf="_isload" class="ant-select-loading">
        <i class="anticon anticon-loading anticon-spin"></i>
      </div>
      <div class="ant-select-selection__placeholder" [hidden]="_tagsOptions.length || _isload">
        {{_placeholder}}
      </div>
      <ul *ngIf="_mode">
        <li *ngFor="let option of _tagsOptions" [@tagAnimation] [attr.title]="option?.label" class="ant-select-selection__choice"
          style="-webkit-user-select: none;">
          <div class="ant-select-selection__choice__content">
            {{option[_antLabel]}}
          </div>
          <span class="ant-select-selection__choice__remove" (click)="unSelectMultipleOption(option,$event)"></span>
        </li>
      </ul>
      <div *ngIf="!_mode" class="ant-select-selection-selected-value">
        <span *ngFor="let option of _tagsOptions;let i = index;">{{option[_antLabel]}}</span>
      </div>
    </div>
    <span (click)="clearSelect($event)" id="_clear" class="ant-select-selection__clear" style="-webkit-user-select: none;" *ngIf="_tagsOptions.length==1&&!_mode">
  </span>
    <span class="ant-select-arrow"><b></b></span>
  </div>


  <div class="ant-select-dropdown ant-select-dropdown--multiple ant-select-dropdown-placement-bottomLeft ng-trigger ng-trigger-dropDownAnimation"
    [@dropDownAnimation]="bottom" *ngIf="_isOpen" [ngClass]="{'ant-select-dropdown--tags': !_mode ,
'ant-select-dropdown--multiple': _mode }" [style.width]="_antWidth">
    <div>
      <div class="ant-select-search">
        <i class="anticon anticon-search ant-select-search-anticon"></i>
        <input type="text" [placeholder]="_searchPlaceholder" class="ant-select-search-input" [(ngModel)]="searchText" (ngModelChange)="_searchData($event)">
      </div>
      <ul class="ant-select-dropdown-menu ant-select-dropdown-menu-vertical ant-select-dropdown-menu-root" #dropdownUl>
        <li *ngFor="let option of filterSpecificOption;let i = index;" class="ant-select-dropdown-menu-item" (click)="clickOption(option,$event)"
          [class.ant-select-dropdown-menu-item-disabled]="option?.nzDisabled" [class.ant-select-dropdown-menu-item-selected]="isInSet(_tagsOptions,option)"
          class="ant-select-dropdown-menu-item">
          {{option[_antLabel] || option.content}}
        </li>
      </ul>
      <div class="ant-select-page" *ngIf="_total>1">
        <span class="ant-select-page-less" (click)="pageLess()" [ngClass]="{'ant-select-page-disabled':curNum == 1}">上一页</span>
        <span class="ant-select-page-num">
        <span class="ant-select-page-num-cur">{{curNum}}</span>
        <span class="ant-select-page-num-spe">/</span>
        <span class="ant-select-page-num-total">{{ _total }}
        </span>
        </span>
        <span class="ant-select-page-next" (click)="pageNext()" [ngClass]="{'ant-select-page-disabled':curNum == _total}">下一页</span>
      </div>
    </div>
  </div>
</div>`,
  styles: [`.ant-select {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  color: rgba(0, 0, 0, 0.65);
  font-size: 12px;
}
.ant-select > ul > li > a {
  padding: 0;
  background-color: #fff;
}
.ant-select-arrow {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  top: 50%;
  right: 8px;
  line-height: 1;
  margin-top: -6px;
  display: inline-block;
  font-size: 12px;
  font-size: 9px \9;
  transform: scale(0.75) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
}
.ant-select-arrow:before {
  display: block;
  font-family: "anticon" !important;
}
:root .ant-select-arrow {
  filter: none;
}
:root .ant-select-arrow {
  font-size: 12px;
}
.ant-select-arrow * {
  display: none;
}
.ant-select-arrow:before {
  content: "\\e61d";
  transition: transform 0.2s ease;
}
.ant-select-selection {
  outline: none;
  user-select: none;
  box-sizing: border-box;
  display: block;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select-selection:hover {
  border-color: #49a9ee;
}
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-select-selection__clear {
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  text-rendering: auto;
  opacity: 0;
  position: absolute;
  right: 8px;
  z-index: 1;
  background: #fff;
  top: 50%;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  width: 12px;
  height: 12px;
  margin-top: -6px;
  line-height: 12px;
  cursor: pointer;
  transition: color 0.3s ease, opacity 0.15s ease;
}
.ant-select-selection__clear:before {
  display: block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e62e";
}
.ant-select-selection__clear:hover {
  color: rgba(0, 0, 0, 0.43);
}
.ant-select-selection:hover .ant-select-selection__clear {
  opacity: 1;
}
.ant-select-selection-selected-value {
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  padding-right: 14px;
}
.ant-select-disabled {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-disabled .ant-select-selection {
  background: #f7f7f7;
  cursor: not-allowed;
}
.ant-select-disabled .ant-select-selection:hover,
.ant-select-disabled .ant-select-selection:focus,
.ant-select-disabled .ant-select-selection:active {
  border-color: #d9d9d9;
  box-shadow: none;
}
.ant-select-disabled .ant-select-selection__clear {
  display: none;
  visibility: hidden;
  pointer-events: none;
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice {
  background: #eee;
  color: #aaa;
  padding-right: 10px;
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice__remove {
  display: none;
}
.ant-select-selection--single {
  height: 28px;
  position: relative;
  cursor: pointer;
}
.ant-select-selection__rendered {
  display: block;
  margin-left: 7px;
  margin-right: 7px;
  position: relative;
  line-height: 26px;
}
.ant-select-selection__rendered:after {
  content: '.';
  visibility: hidden;
  pointer-events: none;
  display: inline-block;
  width: 0;
}
.ant-select-lg .ant-select-selection--single {
  height: 32px;
}
.ant-select-lg .ant-select-selection__rendered {
  line-height: 30px;
}
.ant-select-lg .ant-select-selection--multiple {
  min-height: 32px;
}
.ant-select-lg .ant-select-selection--multiple .ant-select-selection__rendered li {
  height: 24px;
  line-height: 24px;
}
.ant-select-lg .ant-select-selection--multiple .ant-select-selection__clear {
  top: 16px;
}
.ant-select-sm .ant-select-selection--single {
  height: 22px;
}
.ant-select-sm .ant-select-selection__rendered {
  line-height: 20px;
}
.ant-select-sm .ant-select-selection--multiple {
  min-height: 22px;
}
.ant-select-sm .ant-select-selection--multiple .ant-select-selection__rendered li {
  height: 14px;
  line-height: 14px;
}
.ant-select-sm .ant-select-selection--multiple .ant-select-selection__clear {
  top: 11px;
}
.ant-select-disabled .ant-select-selection__choice__remove {
  color: rgba(0, 0, 0, 0.25);
  cursor: default;
}
.ant-select-disabled .ant-select-selection__choice__remove:hover {
  color: rgba(0, 0, 0, 0.25);
}
.ant-select-search__field__wrap {
  display: inline-block;
  position: relative;
}
.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
  position: absolute;
  top: 50%;
  left: 0;
  right: 9px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 20px;
  height: 20px;
  max-width: 100%;
  margin-top: -10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.ant-select-search__field__placeholder {
  left: 8px;
}
.ant-select-search--inline {
  position: absolute;
  height: 100%;
  width: 100%;
}
.ant-select-selection--multiple .ant-select-search--inline {
  float: left;
  position: static;
}
.ant-select-search--inline .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}
.ant-select-search--inline .ant-select-search__field {
  border-width: 0;
  font-size: 100%;
  height: 100%;
  width: 100%;
  background: transparent;
  outline: 0;
  border-radius: 4px;
}
.ant-select-search--inline .ant-select-search__field__mirror {
  position: absolute;
  top: 0;
  left: -9999px;
  white-space: pre;
  pointer-events: none;
}
.ant-select-search--inline > i {
  float: right;
}
.ant-select-selection--multiple {
  min-height: 28px;
  cursor: text;
  padding-bottom: 3px;
  zoom: 1;
}
.ant-select-selection--multiple:before,
.ant-select-selection--multiple:after {
  content: " ";
  display: table;
}
.ant-select-selection--multiple:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.ant-select-selection--multiple .ant-select-search--inline {
  width: auto;
  padding: 0;
  max-width: 100%;
}
.ant-select-selection--multiple .ant-select-search--inline .ant-select-search__field {
  max-width: 100%;
  width: 0.75em;
}
.ant-select-selection--multiple .ant-select-selection__rendered {
  margin-left: 5px;
  margin-bottom: -3px;
  height: auto;
}
.ant-select-selection--multiple > ul > li,
.ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  margin-top: 3px;
  height: 20px;
  line-height: 20px;
}
.ant-select-selection--multiple .ant-select-selection__choice {
  color: rgba(0, 0, 0, 0.65);
  background-color: #f3f3f3;
  border-radius: 4px;
  cursor: default;
  float: left;
  margin-right: 4px;
  max-width: 99%;
  position: relative;
  overflow: hidden;
  transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  padding: 0 20px 0 10px;
}
.ant-select-selection--multiple .ant-select-selection__choice__disabled {
  padding: 0 10px;
}
.ant-select-selection--multiple .ant-select-selection__choice__content {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.43);
  line-height: inherit;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: inline-block;
  font-size: 12px;
  font-size: 8px \9;
  transform: scale(0.66666667) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  position: absolute;
  right: 4px;
  padding: 0 0 0 8px;
  top: 0;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:before {
  display: block;
  font-family: "anticon" !important;
}
:root .ant-select-selection--multiple .ant-select-selection__choice__remove {
  filter: none;
}
:root .ant-select-selection--multiple .ant-select-selection__choice__remove {
  font-size: 12px;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:hover {
  color: #404040;
}
.ant-select-selection--multiple .ant-select-selection__choice__remove:before {
  content: "\\e633";
}
.ant-select-selection--multiple .ant-select-selection__clear {
  top: 14px;
}
.ant-select-allow-clear .ant-select-selection--multiple .ant-select-selection__rendered {
  margin-right: 20px;
}
.ant-select-open .ant-select-arrow {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  -ms-transform: rotate(180deg);
}
.ant-select-open .ant-select-arrow:before {
  transform: rotate(180deg);
}
.ant-select-open .ant-select-selection {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-select-combobox .ant-select-arrow {
  display: none;
}
.ant-select-combobox .ant-select-search--inline {
  height: 100%;
  width: 100%;
  float: none;
}
.ant-select-combobox .ant-select-search__field__wrap {
  width: 100%;
  height: 100%;
}
.ant-select-combobox .ant-select-search__field {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  box-shadow: none;
}
.ant-select-combobox.ant-select-allow-clear .ant-select-selection:hover .ant-select-selection__rendered {
  margin-right: 20px;
}
.ant-select-dropdown {
  background-color: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  box-sizing: border-box;
  z-index: 1050;
  left: -9999px;
  top: -9999px;
  position: absolute;
  outline: none;
  overflow: hidden;
  font-size: 12px;
}
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-bottomLeft,
.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpIn;
}
.ant-select-dropdown.slide-up-enter.slide-up-enter-active.ant-select-dropdown-placement-topLeft,
.ant-select-dropdown.slide-up-appear.slide-up-appear-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownIn;
}
.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-bottomLeft {
  animation-name: antSlideUpOut;
}
.ant-select-dropdown.slide-up-leave.slide-up-leave-active.ant-select-dropdown-placement-topLeft {
  animation-name: antSlideDownOut;
}
.ant-select-dropdown-hidden {
  display: none;
}
.ant-select-dropdown-menu {
  outline: none;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  max-height: 250px;
  overflow: auto;
}
.ant-select-dropdown-menu-item-group-list {
  margin: 0;
  padding: 0;
}
.ant-select-dropdown-menu-item-group-list > .ant-select-dropdown-menu-item {
  padding-left: 16px;
}
.ant-select-dropdown-menu-item-group-title {
  color: rgba(0, 0, 0, 0.43);
  line-height: 1.5;
  padding: 8px;
}
.ant-select-dropdown-menu-item {
  position: relative;
  display: block;
  padding: 7px 8px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;
  transition: background 0.3s ease;
}
.ant-select-dropdown-menu-item:hover {
  background-color: #ecf6fd;
}
.ant-select-dropdown-menu-item-active {
  background-color: #ecf6fd;
}
.ant-select-dropdown-menu-item-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-select-dropdown-menu-item-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #fff;
  cursor: not-allowed;
}
.ant-select-dropdown-menu-item-selected,
.ant-select-dropdown-menu-item-selected:hover {
  background-color: #f7f7f7;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.65);
}
.ant-select-dropdown-menu-item-divider {
  height: 1px;
  margin: 1px 0;
  overflow: hidden;
  background-color: #e5e5e5;
  line-height: 0;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e632";
  color: transparent;
  display: inline-block;
  font-size: 12px;
  font-size: 10px \9;
  transform: scale(0.83333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  transition: all 0.2s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  font-weight: bold;
  text-shadow: 0 0.1px 0, 0.1px 0 0, 0 -0.1px 0, -0.1px 0;
}
:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {
  filter: none;
}
:root .ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:after {
  font-size: 12px;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item:hover:after {
  color: #ddd;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-disabled:after {
  display: none;
}
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:after,
.ant-select-dropdown.ant-select-dropdown--multiple .ant-select-dropdown-menu-item-selected:hover:after {
  color: #108ee9;
  display: inline-block;
}
.ant-select-dropdown-container-open .ant-select-dropdown,
.ant-select-dropdown-open .ant-select-dropdown {
  display: block;
}
/***/
nz-select .ant-select {
  width: 100%;
}
.ant-select-dropdown {
  top: 100%;
  left: 0;
  position: relative;
  width: 100%;
  margin-top: 4px;
  margin-bottom: 4px;
}
.ant-select-dropdown.ant-select-dropdown-placement-topLeft {
  top: -100%;
  transform: translateY(-100%) !important;
}
.ant-select-dropdown-menu-item {
  line-height: 1.5;
}
.nz-overlay-pane {
  position: absolute;
}
.ant-select-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 2em;
  padding: 5px;
  user-select: none;
  text-align: center;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}
.ant-select-page-less,
.ant-select-page-next {
  color: #333;
  cursor: pointer;
}
.ant-select-page-disabled {
  color: #999!important;
  cursor: not-allowed !important;
}
.ant-select-search {
  background-color: #fff;
  padding: 4px;
  position: relative;
}
.ant-select-search-input {
  width: 100%;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #eee;
}
.ant-select-search-input:focus {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-select-search-anticon {
  position: absolute;
  right: 13px;
  top: 11px;
  font-size: 15px;
  font-weight: 600;
  color: #999;
  cursor: pointer;
  height: 53%;
}
.ant-select-loading {
  position: absolute;
  left: 5px;
  top: -1px;
}
.nz-overlay-contain {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
}
.ant-select-dropdown {
  position: absolute!important;
  top: auto;
  left: auto;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d7d7d7;
}
`]
})
export class SelectComponent implements OnInit, OnChanges, ControlValueAccessor {
  _prefixCls = `ant-select`;
  _el: HTMLElement;
  _isload = true;
  _isOpen = false;
  _size: string;
  _triggerWidth = 0;
  antSelectValue = [];
  onChange: any = Function.prototype;
  onTouched: any = Function.prototype;
  _placeholder = 'ploceholder';
  _selecteOptions = [];
  _tagsOptions = [];
  filterSpecificOption: Object[];
  _total: number;
  curNum = 1;
  _NotFoundContent = '无法找到';
  options: Object[];
  searchText: string;
  _mode = true;
  _containerElement: HTMLElement;
  _antLabel: string;
  _antValue: string;
  _antWidth = '150px';
  _searchPlaceholder = '请输入关键字搜索';
  private searchSource = new Subject<string>();
  @ViewChild('antSelect') _selectDom: ElementRef;
  @ViewChild('rootEl') _rootEl: ElementRef;
  @Output() afterSelect: EventEmitter<any> = new EventEmitter();
  @Input() set antploceholder(value: string) {
    if (value !== undefined) {
      this._placeholder = value;
    }
  }
  @Input() set antLabel(value: string) {
    if (value !== undefined) {
      this._antLabel = value;
    }
  }
  @Input() set antWidth(value: number) {
    if (value !== undefined) {
      this._antWidth = value + 'px';
    }
  }
  @Input() set antValue(value: string) {
    if (value !== undefined) {
      this._antValue = value;
    }
  }
  @Input() set antSearchPlaceholder(value: string) {
    if (value !== undefined) {
      this._searchPlaceholder = value;
    }
  }
  @Input() set antNotFoundContent(value: string) {
    if (value !== undefined) {
      this._NotFoundContent = value;
    }
  }
  @Input()
  get antSize(): string {
    return this._size;
  };
  set antSize(value: string) {
    this._size = { large: 'lg', small: 'sm' }[ value ];
    this.setClassMap();
  }
  @Input() set antMode(value: 'multiple' | 'single') {
    if (value !== undefined) {
      if (value === 'multiple') {
        this._mode = true;
      } else {
        this._mode = false;
      }
    }
  }
  @Input() selecteOptions: Object[];
  @HostListener('document:click', ['$event'])
  onClick(btn: Event) {
      if (!this._elementRef.nativeElement.contains(event.target)) {
        // 关闭select
        // this._isDatepickerHide = false;
        this._isOpen = false; 
        this._renderer.removeClass(this._selectDom.nativeElement, `${this._prefixCls}-open`);
      }
  }
  /**
   * 双向绑定，接收数据
   */
  writeValue(value: string[]) {
    if (value !== undefined) {
      this.antSelectValue = value;
      if (this._selecteOptions.length) {
        this.resetTagsOptions();
      }
    }
  }
  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2,
    private ctp: ChineseToPinyinService
  ) {
    this._el = this._elementRef.nativeElement;
  }

  ngOnInit() {
    this.setClassMap();
    // this._setTriggerWidth();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selecteOptions) {
      let selecteOptions = changes.selecteOptions;
      if (!selecteOptions.firstChange) {
        // 拼音搜索
        for (let i = 0; i < selecteOptions.currentValue.length; i++) {
          selecteOptions.currentValue[i].spell = this.ctp.ConvertPinyin({ chinas: selecteOptions.currentValue[i][this._antLabel] });
          selecteOptions.currentValue[i].first = this.ctp.ConvertPinyin({ chinas: selecteOptions.currentValue[i][this._antLabel], first: true });
        }
        this._selecteOptions = selecteOptions.currentValue;
        this.options = selecteOptions.currentValue;
        this._isload = false;
        this.filterSpecificOption = selecteOptions.currentValue.slice(0, 10);
        this.total();
        this.resetTagsOptions();
      }
    }
  }
  /**
   * 是否显示下拉
   * @memberof SelectComponent
   */
  isSelect(e) {
    if (this._isload) {
      return;
    }
    if (e.target.id === '_clear') {
      return;
    }
    this._isOpen = !this._isOpen;
    if (this._isOpen) {
      this._renderer.addClass(this._selectDom.nativeElement, `${this._prefixCls}-open`);
      // this.searchText = '';
      // this.options = this._selecteOptions;
      /**
      * 创建容器
      */
      // this._createBackdropElement();
      setTimeout(() => {
        this._renderer.selectRootElement('.ant-select-search-input').focus();
      })
    } else {
      this._renderer.removeClass(this._selectDom.nativeElement, `${this._prefixCls}-open`);
      // this._removeBackdrop();
    }
  }
  setClassMap(): void {
    this._renderer.addClass(this._selectDom.nativeElement, this._prefixCls);
    this._renderer.setStyle(this._selectDom.nativeElement, 'width', this._antWidth);
     this.removeClass();
    if (this._size) {
      this._renderer.addClass(this._rootEl.nativeElement, `${this._prefixCls}-${this._size}`);
    }else {
      this.removeClass();
    }
  }
  removeClass() {
    this._renderer.removeClass(this._rootEl.nativeElement, `${this._prefixCls}-lg`);
    this._renderer.removeClass(this._rootEl.nativeElement, `${this._prefixCls}-sm`);
  }
  // _setTriggerWidth(): void {
  //   this._triggerWidth = this._getTriggerRect().width;
  // }
  // _getTriggerRect(): ClientRect {
  //   return this._selectDom.nativeElement.getBoundingClientRect();
  // }
  /**
   * 删除
   */
  unSelectMultipleOption(option, $event?) {
    if ((this._tagsOptions.indexOf(option) !== -1)) {
      this._tagsOptions.splice(this._tagsOptions.indexOf(option), 1);
      this.afterSelect.emit(this._tagsOptions);
      this.onChange(this._tagsOptions.map(item => item[this._antValue]));
    }
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }
  /**
   * 选择
   */
  clickOption(option, $event?) {
    if (!option[this._antValue]) {
      return;
    }
    if (!this._mode) {
      this._tagsOptions = [];
      this._tagsOptions.push(option);
      this._backdropClick();
      this.afterSelect.emit(this._tagsOptions);
      this.onChange(this._tagsOptions.map(item => item[this._antValue]));
      return;
    }
    if ((this._tagsOptions.indexOf(option) !== -1)) {
      this._tagsOptions.splice(this._tagsOptions.indexOf(option), 1);
    }else {
      this._tagsOptions.push(option);
    }
    this.afterSelect.emit(this._tagsOptions);
    this.onChange(this._tagsOptions.map(item => item[this._antValue]));
  }
  clearSelect(e) {
    this._tagsOptions = [];
    this.onChange(this._tagsOptions);
    this.afterSelect.emit(this._tagsOptions);
  }
  total() {
    this._total = Math.ceil(this.options.length / 10);
  }
  filterData() {
    if (this.curNum === this._total) {
      this.filterSpecificOption = this.options.slice((this.curNum - 1) * 10);
      return;
    }
    this.filterSpecificOption = this.options.slice((this.curNum - 1) * 10, this.curNum * 10);
  }
  pageNext() {
    if (this._total === this.curNum) {
      return;
    }
    this.curNum += 1;
    this.filterData();
  }
  pageLess() {
    if (this.curNum === 1) {
      return;
    }
    this.curNum -= 1;
    this.filterData();
  }
  /**
   * 搜索
   */
  _searchData(text) {
    this.options = this._selecteOptions;
    let resultArr = this.screenData(text);
    this.curNum = 1;
    if (resultArr.length) {
      this.options = resultArr;
      this.total();
      this.filterData();
      return;
    }
    this.options = [{ content: this._NotFoundContent, nzDisabled: true }];
    this._total = 0;
    this.filterData();
  }
  resetTagsOptions() {
    this._tagsOptions = [];
    if (this.antSelectValue.length > 0 && this._selecteOptions.length > 0) {
      this.antSelectValue.forEach(item => {
        this._selecteOptions.forEach(i => {
          if (item === i[this._antValue]) {
            this._tagsOptions.push(i);
          }
        })
      });
    }
  }
  isInSet(arr, option) {
    return arr.some(item => item[this._antValue] === option[this._antValue])
  }
  // protected _createBackdropElement(): void {
  //   const el = this._renderer.createElement('div');
  //   this._renderer.addClass(el, 'nz-overlay-contain');
  //   el.addEventListener('click', () => this._backdropClick());
  //   this._renderer.appendChild(document.body, el)
  // }
  _backdropClick() {
    this._isOpen = false;
    this._renderer.removeClass(this._selectDom.nativeElement, `${this._prefixCls}-open`);
    // this._removeBackdrop();
  }
  protected _removeBackdrop(): void {
    // this._renderer.selectRootElement('.nz-overlay-contain').remove();
  }
  screenData(text): any[] {
    let resultArr = [];
    this.options.forEach((item, index, arr) => {
      if (item[this._antLabel].indexOf(text) > -1 || item['spell'].indexOf(text) > -1 || item['first'].indexOf(text) > -1) {
        resultArr.push(item);
      }
    })
    return resultArr;
  }
}
